var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Post',_vm._b({},'Post',_vm.$props,false),[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('iframe',{staticClass:"center full-width",attrs:{"width":"640","height":"360","src":("https://www.youtube.com/embed/" + _vm.mediaId + "?rel=0&showinfo=0"),"frameborder":"0","allowfullscreen":""}}),_vm._v(" "),_c('br',{staticClass:"hide-on-desktop"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76c313f3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/YoutubePost/YoutubePost.vue
// module id = qbCv
// module chunks = 1